import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/internal/file-version';

export class FileVersionServiceInternal implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  async convertFileVersions({
    body,
  }: types.ConvertFileVersionsParameters): Promise<types.ConvertFileVersionsResponse> {
    const { data } = await this.axios.post<types.ConvertFileVersionsResponse>(
      `/file-version/convert`,
      body,
    );
    return data;
  }
}
